import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransferChange, TransferItem, TransferSelectChange } from 'ng-zorro-antd/transfer';
import { _HttpClient } from '../../net/http.client';
import { ApiService } from 'src/app/core/net/apiRoute';
import { NzModalRef } from 'ng-zorro-antd/modal';
export interface Ret {
  from: string;
  to: string;
  list: any[];
}



@Component({
  selector: 'app-select-department-users',
  templateUrl: './app-select-department-users.component.html',
  styleUrls: ['./app-select-department-users.component.css']
})

export class AppSelectDepartmentUsersComponent implements OnInit {

  @Input() departmentId;  // 输入参数 部门id
  @Input() organizeId;  // 输入参数 组织id
  @Output() transferEvent : EventEmitter<string> = new EventEmitter(); // 输出属性
  list: TransferItem[] = [];

  constructor(
    private http:_HttpClient,
    private modalRef:NzModalRef<any>,
    )
  { }

  ngOnInit(): void {
    this.getData(this.departmentId,this.organizeId);
  }

  // tslint:disable-next-line:no-any
  filterOption(inputValue: string, item: any): boolean {
    return item.description.indexOf(inputValue) > -1;
  }

  search(ret: {}): void {
    console.log('nzSearchChange', ret);
  }

  select(ret: {}): void {
    console.log('nzSelectChange', ret);
  }

  change(ret: Ret): void {
    let direction = 0;
    var ids = ret.list.map(x=>x.key);
    if(ret.from !="left"){
        // 左=>右 移入 ; 右=>左边 移出
        direction = 1;
    }
    this.transferMembers(this.departmentId,ids,direction);
  }

  /**
   * 获取指定部门的员工列表
   * @param departmentId  部门ID
   * @param organizeId    公司ID
   */
  getData(departmentId,organizeId):any{
    this.http.get(ApiService.GetMembersByDepartment, {
      departmentId: departmentId,
      organizeId:organizeId
    }, false)
      .subscribe((res: any) => {
        this.list = res.Result;
      });
  }

  /**
   * 将成员移入/移除部门
   * @param departmentId  部门id
   * @param userIds  选中用户
   * @param direction  方向 1.移出 0.移入
   */
  transferMembers(departmentId,userIds,direction)
  {
    this.http.post(ApiService.TransferMembers, {
      departmentId: departmentId,
      userIds:userIds,
      direction:direction
    }, true)
      .subscribe((res: any) => {
        this.modalRef.close('reload');
      });
  }
}
